"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8829],{

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ LandingCurrDelParent; },
/* harmony export */   "Ix": function() { return /* binding */ LandingCurrDelInfo; },
/* harmony export */   "Mz": function() { return /* binding */ LandingCurrDelWrap; },
/* harmony export */   "Ob": function() { return /* binding */ FootNote; },
/* harmony export */   "PW": function() { return /* binding */ PoweredByText; },
/* harmony export */   "QU": function() { return /* binding */ LandingCurrDelList; },
/* harmony export */   "iq": function() { return /* binding */ LandingCurrDelLeft; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "kc": function() { return /* binding */ LandingCurrDel; },
/* harmony export */   "nb": function() { return /* binding */ LandingCurrDelTitle; },
/* harmony export */   "oX": function() { return /* binding */ LandingCurrDelpara; }
/* harmony export */ });
/* unused harmony exports CheckBtn, LandingCurrDelFlex, LandingCurrDelCity */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5505);

var LandingCurrDelParent = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelParent",
  componentId: "sc-1nuhlke-0"
})(["background:#000;margin-top:-1px;"]);
var LandingCurrDel = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDel",
  componentId: "sc-1nuhlke-1"
})(["background:#ffffff;position:relative;border-radius:16px;left:0px;right:0px;bottom:24px;display:flex;padding:34px 16px;width:100%;bottom:-60px;& input{background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;margin-right:8px;padding:10px;font-weight:400;font-size:16px;line-height:19px;}& input.disable{opacity:0.3;pointer-events:none;}input.focus{outline:none;border:1px solid #008cff !important;}& input.error{border:1px solid red;}.curr1,.curr2,.curr3{position:absolute;width:92px;height:92px;transform:rotate(45deg);}& .curr1{top:82px;left:9px;z-index:7;}& .curr2{top:82px;left:35px;z-index:6;}& .curr3{top:82px;left:58px;z-index:5;}"]);
var Flex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__Flex",
  componentId: "sc-1nuhlke-2"
})(["display:flex;align-items:center;"]);
var LandingCurrDelWrap = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelWrap",
  componentId: "sc-1nuhlke-3"
})(["display:flex;margin:0 auto;background:#fff;flex-direction:column;"]);
var LandingCurrDelLeft = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelLeft",
  componentId: "sc-1nuhlke-4"
})(["background:linear-gradient( 159.48deg,#e3fffd 4.69%,rgba(230,237,255,0.736176) 27.76%,#d6e8f4 92.13% );border-radius:14px;padding:24px;margin-bottom:32px;position:relative;"]);
var LandingCurrDelTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelTitle",
  componentId: "sc-1nuhlke-5"
})(["font-family:\"Raleway\";font-style:normal;font-weight:500;font-size:28px;line-height:36px;width:100%;color:#000000;margin-bottom:32px;"]);
var CheckBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].button.withConfig({
  displayName: "LandingCurrDelstyle__CheckBtn",
  componentId: "sc-1nuhlke-6"
})(["background:#ffffff;box-shadow:0px 1px 7px rgba(0,0,0,0.21);border-radius:6px;font-weight:900;font-size:16px;line-height:20px;color:#000;outline:none;border:none;cursor:pointer;width:102px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center;"]);
var LandingCurrDelFlex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelFlex",
  componentId: "sc-1nuhlke-7"
})(["display:flex;position:relative;height:120px;& img{width:122px;height:122px;flex-shrink:0;position:absolute;}& img:first-child{z-index:3;left:0;}& img:nth-child(2){z-index:2;left:21px;top:1px;}& img:last-child{z-index:1;left:54px;top:-3px;}"]);
var LandingCurrDelInfo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelInfo",
  componentId: "sc-1nuhlke-8"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;color:#4a4a4a;margin-bottom:24px;font-size:16px;line-height:24px;font-style:normal;width:100%;& .bold{font-weight:700;}"]);
var LandingCurrDelCity = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelCity",
  componentId: "sc-1nuhlke-9"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:16px;line-height:24px;color:#4a4a4a;position:relative;margin-bottom:8px;&:after{content:\"\";position:absolute;background:#d9d9d9;border-radius:15px;width:40px;height:4px;top:-4px;left:0;}em{color:#22936a;margin-bottom:8px;font-weight:700;font-style:normal;}"]);
var LandingCurrDelpara = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelpara",
  componentId: "sc-1nuhlke-10"
})(["font-family:\"Avenir\";font-style:normal;font-weight:500;font-size:18px;line-height:24px;color:#000000;margin-bottom:110px;"]);
var LandingCurrDelList = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].ul.withConfig({
  displayName: "LandingCurrDelstyle__LandingCurrDelList",
  componentId: "sc-1nuhlke-11"
})(["font-size:14px;line-height:20px;line-height:32px;padding-left:18px;gap:10px;margin-bottom:12px;& li{position:relative;}& li:after{content:\"\";position:absolute;width:5px;height:14px;left:-18px;top:9px;background:#a07419;border-radius:14px;}& .yellowText{background:linear-gradient(86.88deg,#9d8523 0%,#dab90b 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}& .greenText{background:linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}& .bold{background:linear-gradient(0deg,#000000,#000000),linear-gradient(93.66deg,#249083 0%,#249054 100%),#ffffff;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;text-fill-color:transparent;font-weight:700;}"]);
var FootNote = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(Flex).withConfig({
  displayName: "LandingCurrDelstyle__FootNote",
  componentId: "sc-1nuhlke-12"
})(["position:absolute;bottom:38px;"]);
var PoweredByText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
  displayName: "LandingCurrDelstyle__PoweredByText",
  componentId: "sc-1nuhlke-13"
})(["font-family:\"Open Sans Light\",sans-serif;font-weight:400;font-size:12px;line-height:16px;color:#000000;margin-right:20px;"]);

/***/ }),

/***/ 8829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ foreignCurrencyForex; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/BulletList/index.tsx + 1 modules
var BulletList = __webpack_require__(907);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/markdown/index.tsx + 1 modules
var markdown = __webpack_require__(8741);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/foreignCurrencyForex/index.style.ts


var LandingCurrDelParent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelParent",
  componentId: "sc-10uu9z5-0"
})(["background:", ";"], colors/* BG_COLOR.black */.VR.black);
var LandingCurrDel = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDel",
  componentId: "sc-10uu9z5-1"
})(["background:", ";padding:84px 0;position:relative;margin:0 auto;width:1200px;border-radius:16px;left:0px;right:0px;bottom:90px;display:flex;& input{background:", ";border:1px solid ", ";border-radius:4px;margin-right:8px;padding:10px;font-weight:400;font-size:14px;line-height:19px;}& input.disable{opacity:0.3;pointer-events:none;}input.focus{outline:none;border:1px solid ", " !important;}& input.error{border:1px solid red;}.curr1,.curr2,.curr3{position:absolute;width:140px;height:140px;transform:rotate(45deg);visibility:visible;}& .curr1{top:110px;left:216px;z-index:7;}& .curr2{top:110px;left:264px;z-index:6;}& .curr3{top:110px;left:310px;z-index:5;}"], colors/* BG_COLOR.white */.VR.white, colors/* BG_COLOR.white */.VR.white, colors/* BORDER_COLOR.lightGrey */.dS.lightGrey, colors/* BLUE_COLOR.300 */.vX[300]);
var LandingCurrDelWrap = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelWrap",
  componentId: "sc-10uu9z5-2"
})(["display:flex;margin:0 auto;background:", ";width:1200px !important;"], colors/* BG_COLOR.white */.VR.white);
var LandingCurrDelLeft = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelLeft",
  componentId: "sc-10uu9z5-3"
})(["background:linear-gradient( 159.48deg,", " 4.69%,", " 27.76%,", " 92.13% );border-radius:14px;padding:38px 42px 70px;margin-right:75px;visibility:hidden;position:relative;"], colors/* GRADIENT_COLOR.lightCyan */.oi.lightCyan, colors/* GRADIENT_COLOR.lightSalmon */.oi.lightSalmon, colors/* GRADIENT_COLOR.lightBlue0 */.oi.lightBlue0);
var LandingCurrDelFlex = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelFlex",
  componentId: "sc-10uu9z5-4"
})(["display:flex;position:relative;height:120px;& img{width:122px;height:122px;flex-shrink:0;position:absolute;}& img:first-child{z-index:3;left:0;}& img:nth-child(2){z-index:2;left:21px;top:1px;}& img:last-child{z-index:1;left:54px;top:-3px;}"]);
var LandingCurrDelpara = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexstyle__LandingCurrDelpara",
  componentId: "sc-10uu9z5-5"
})(["font-family:\"Avenir\";font-style:normal;font-weight:500;font-size:22px;line-height:30px;color:", ";margin-bottom:177px;"], colors/* TEXT_COLOR.high */.ou.high);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/customerEngagement/index.tsx + 1 modules
var customerEngagement = __webpack_require__(8607);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/poweredBy/index.style.ts
var index_style = __webpack_require__(6609);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 8 modules
var hooks = __webpack_require__(7510);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/LandingCurrDel/LandingCurrDel.style.ts
var LandingCurrDel_style = __webpack_require__(2434);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/foreignCurrencyForex/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var ForeignCurrencyForex = function ForeignCurrencyForex(_ref) {
  var _logos$, _poweredBy$logos, _poweredBy$logos$;

  var foreignCurrencyBenefitsCard = _ref.foreignCurrencyBenefitsCard,
      foreignCurrencyEngagement = _ref.foreignCurrencyEngagement,
      events = _ref.events;

  var _useState = (0,react.useState)(false),
      load = _useState[0],
      setLoad = _useState[1];

  (0,hooks/* useForeignCurrencyAnimation */.MC)();
  var poweredBy = foreignCurrencyBenefitsCard.poweredBy,
      currencyImgs = foreignCurrencyBenefitsCard.currencyImgs;

  var _ref2 = poweredBy || {},
      title = _ref2.title,
      logos = _ref2.logos;

  var checkPincodeHandler = function checkPincodeHandler() {
    setLoad(!load); //@TODO: Need to implement.
  };

  var buyForeignCurrencyHandler = function buyForeignCurrencyHandler() {//@TODO: Need redirection Url.
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelParent, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDel, {
      id: "curr_ref",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingCurrDelWrap, {
        id: "pad_ref",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LandingCurrDelLeft, {
          id: "curr_del_left",
          children: [(foreignCurrencyBenefitsCard === null || foreignCurrencyBenefitsCard === void 0 ? void 0 : foreignCurrencyBenefitsCard.title) && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingCurrDelpara, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(markdown/* Markdown */.U, {
              children: foreignCurrencyBenefitsCard.title
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
            id: "curr1",
            className: "curr1"
          }, currencyImgs === null || currencyImgs === void 0 ? void 0 : currencyImgs[0])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
            id: "curr2",
            className: "curr2"
          }, currencyImgs === null || currencyImgs === void 0 ? void 0 : currencyImgs[1])), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, _objectSpread({
            id: "curr3",
            className: "curr3"
          }, currencyImgs === null || currencyImgs === void 0 ? void 0 : currencyImgs[2])), /*#__PURE__*/(0,jsx_runtime.jsx)(BulletList/* BulletList */.D, {
            bulletColor: colors/* BG_COLOR.bistreBrown */.VR.bistreBrown,
            list: foreignCurrencyBenefitsCard.foreignCurrencyBenefitsList
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingCurrDel_style/* FootNote */.Ob, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_style/* PoweredByText */.P, {
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* Image */.E, {
              alt: logos === null || logos === void 0 ? void 0 : (_logos$ = logos[0]) === null || _logos$ === void 0 ? void 0 : _logos$.alt,
              src: poweredBy === null || poweredBy === void 0 ? void 0 : (_poweredBy$logos = poweredBy.logos) === null || _poweredBy$logos === void 0 ? void 0 : (_poweredBy$logos$ = _poweredBy$logos[0]) === null || _poweredBy$logos$ === void 0 ? void 0 : _poweredBy$logos$.src,
              width: "107",
              height: "37"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(customerEngagement/* CustomerEngagement */.M, _objectSpread(_objectSpread({}, foreignCurrencyEngagement), {}, {
          offering: "BMF",
          checkPincodeHandler: checkPincodeHandler,
          onClick: buyForeignCurrencyHandler,
          events: events
        }))]
      })
    })
  });
};

/* harmony default export */ var foreignCurrencyForex = (ForeignCurrencyForex);

/***/ })

}]);